export default {
  path: 'markingQualityMonitor',
  name: 'markingQualityMonitor',
  component: () => import('./MarkingQualityMonitor.vue'),
  meta: {
    title: '阅卷质量监控'
  }
}
